import { FC, memo, NamedExoticComponent } from "react";
import equal from "fast-deep-equal";

export function deepMemo<P extends object>(
  Component: FC<P>
): NamedExoticComponent<P> {
  return memo(Component, equal);
}
